// extracted by mini-css-extract-plugin
export default {"icon":"x_cq"};